import { RouteRecordRaw } from 'vue-router';
import modules from './modules/index';

// 配置这个文件是 解决错误：找不到模块“@/views/login/index.vue”或其相应的类型声明。ts(2307)
// 这段代码告诉 TypeScript，所有以 .vue 结尾的文件都是 Vue 组件，可以通过 import 语句进行导入。这样做通常可以解决无法识别模块的问题。

/**
 * Note: 路由配置项
 *
 * name:'router-name'               // 设定路由的名字，一定要填写路由跳转使用name进行跳转
 * meta : {
 needCache: true                   // 如果设置为true，则会被 <keep-alive> 缓存(默认 false)
 header: true                     // 是否显示顶部菜单
 footer: true                     // 是否显示底部菜单
 login: true                     // 登录才能访问
 loading: true                     // 是否需要显示加载等待
 refresh: true                     // 是否需要下拉刷新
 noAnimation: true                // 当设置 true 的时候该路由不会有切换动画(默认 false)
 * }
 */
const routes: RouteRecordRaw[] = [
  // base route
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home/:mainType?/:subType?', // mainType: 游戏主分组type subType: 二级分组
    name: 'home',
    component: () => import('@/pages/home/index.vue'),
    meta: {
      needCache: true,
      footer: true,
      header: true,
      refresh: true,
      loading: true,
    },
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/pages/video/index.vue'),
    meta: {
      needCache: true,
      footer: true,
      header: true,
      refresh: true,
      loading: true,
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/pages/video/search.vue'),
    meta: {
      needCache: false,
      footer: true,
      loading: false,
    },
  },
  {
    path: '/videoList',
    name: 'videoList',
    component: () => import('@/pages/video/videoList.vue'),
    meta: {
      needCache: false,
      refresh: true,
      loading: true,
    },
  },
  {
    path: '/classify',
    name: 'classify',
    component: () => import('@/pages/video/classify.vue'),
    meta: {
      needCache: false,
      refresh: true,
      loading: true,
    },
  },

  {
    path: '/video/:id',
    name: 'video-detail',
    component: () => import('@/pages/video/detail.vue'),
    meta: {
      needCache: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/heiliao_video/:id',
    name: 'heiliao_video-detail',
    component: () => import('@/pages/video/heiliao_detail.vue'),
    meta: {
      needCache: false,
      footer: true,
      loading: false,
    },
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/pages/activity/index.vue'),
    meta: {
      needCache: true,
      header: false,
      login: false,
      footer: true,
      refresh: false,
      loading: false,
    },
  },
  {
    path: '/activity/activityPg',
    name: 'activityPg',
    component: () => import('@/pages/activity/activity/indexpg.vue'),
    meta: {
      needCache: true,
      header: false,
      login: false,
      footer: false,
      refresh: false,
      loading: false,
    },
  },
  {
    path: '/loanDetail',
    name: 'loanDetail',
    component: () => import('@/pages/activity/loan/detail.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/collectWord',
    name: 'collectWord',
    component: () => import('@/pages/activity/activity/collectWord.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/vipDetail',
    name: 'vipDetail',
    component: () => import('@/pages/activity/vip/vipDetail.vue'),
    meta: {
      needCache: false,
      layout: true,
    },
  },
  {
    path: '/vippromotion',
    name: 'vippromotion',
    component: () => import('@/pages/mine/views/vippromotion/index.vue'),
    meta: {
      needCache: false,
      layout: true,
    },
  },

  {
    path: '/activity/investment',
    name: 'investment',
    component: () => import('@/pages/activity/activity/investment.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/relayRoulette',
    name: 'roulette',
    component: () => import('@/pages/activity/activity/relayRoulette/relayRoulette.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/relayRoulette/detail',
    name: 'relayRouletteDetail',
    component: () => import('@/pages/activity/activity/relayRoulette/relayRouletteDetail.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/luckyWheel', // 幸运大转盘
    name: 'LuckyTurntable',
    component: () => import('@/pages/activity/activity/relayRoulette/luckyTurntable.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
      // login: true,
    },
  },
  {
    path: '/activity/prestoreReward', // 预存奖励
    name: 'prestoreReward',
    component: () => import('@/pages/activity/activity/prestoreReward/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/propagate',
    name: 'propagate',
    component: () => import('@/pages/activity/activity/propagate/propagate.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/play',
    name: 'activityPlay',
    component: () => import('@/pages/activity/activity/play/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: true,
      refresh: true,
    },
  },
  {
    path: '/activity/redPackets',
    name: 'activityRedPackets',
    component: () => import('@/pages/activity/activity/RedPacketsRain/detail.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: true,
      refresh: true,
    },
  },
  {
    path: '/activity/custom', //自定义活动111
    name: 'activityCustom',
    component: () => import('@/pages/activity/activity/custom/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: true,
      refresh: true,
    },
  },
  {
    path: '/activity/customActivityApplyRecords', //自定义活动申请记录
    name: 'customActivityApplyRecords',
    component: () => import('@/pages/activity/activity/customActivityApplyRecords/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: true,
      refresh: true,
    },
  },
  {
    path: '/activity/CustomActivityDiscountApply', //自定义活动优惠申请111
    name: 'CustomActivityDiscountApply',
    component: () => import('@/pages/activity/activity/CustomActivityDiscountApply/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: true,
      refresh: true,
    },
  },
  {
    path: '/activity/reliefFund',
    name: 'reliefFund',
    component: () => import('@/pages/activity/activity/reliefFund/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/newcomer', //新人新彩金
    name: 'newcomer',
    component: () => import('@/pages/activity/activity/newcomer/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/newsalary', //分享领工资新（开宝箱）
    name: 'newsalary',
    component: () => import('@/pages/activity/activity/newsalary/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
      login: false,
    },
  },
  {
    path: '/activity/registerBonus', //注册送彩金
    name: 'registerBonus',
    component: () => import('@/pages/activity/activity/registerBonus/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: true,
    },
  },
  {
    path: '/activity/rank', //排行榜
    name: 'activityRank',
    component: () => import('@/pages/activity/activity/rank/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/apply', //活动申请
    name: 'activityApply',
    component: () => import('@/pages/activity/activity/apply/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/detail', //活动详情
    name: 'activityDetail',
    component: () => import('@/pages/activity/activity/detail.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/blindBox',
    name: 'blindBox',
    component: () => import('@/pages/activity/activity/blindBox/blindBox.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/activity/rechargeGift',
    name: 'rechargeActivity',
    component: () => import('@/pages/activity/activity/rechargeGift/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },

  {
    path: '/activity/lucky-bet',
    name: 'lucky-bet',
    component: () => import('@/pages/activity/activity/LuckyBet/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      login: false,
      loading: true,
      refresh: false,
      // customHeader: {
      //   title: '详情',
      //   rightText: '领取记录',
      //   // path: '/mine',
      // },
    },
  },
  {
    path: '/jumph5',
    name: 'jumph5',
    component: () => import('@/pages/jumpurl/jumph5.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/chatPerson',
    name: 'chatPerson',
    component: () => import('@/pages/chatPerson/chatPerson.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/wallet/deposit',
    name: 'deposit',
    component: () => import('@/pages/wallet/deposit/index.vue'),
    meta: {
      needCache: true,
      header: false,
      footer: true,
      login: true,
      loading: true,
      refresh: false,
    },
  },
  {
    path: '/wallet/record',
    name: 'record',
    component: () => import('@/pages/wallet/record/index.vue'),
    meta: {
      needCache: true,
      footer: false,
      login: true,
      loading: true,
      refresh: false,
      customHeader: {
        title: '交易记录',
      },
    },
  },
  {
    path: '/wallet/withdrawal',
    name: 'withdrawal',
    component: () => import('@/pages/wallet/withdrawal/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      login: true,
      loading: true,
      refresh: true,
    },
  },
  {
    path: '/wallet/iframe',
    name: 'wallet-iframe',
    component: () => import('@/pages/wallet/iframe/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      login: true,
      loading: false,
      refresh: false,
    },
  },
  {
    path: '/wallet/pay',
    name: 'wallet-pay',
    component: () => import('@/pages/wallet/PayLoading.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      login: false,
      loading: false,
      refresh: false,
    },
  },
  {
    path: '/game',
    redirect: '/home',
    component: () => import('@/pages/games/index.vue'),
    children: [
      {
        path: 'iframe',
        name: 'game-iframe',
        component: () => import('@/pages/games/iframe/index.vue'),
        meta: {
          needCache: false,
          header: false,
          footer: false,
          login: false,
          loading: false,
        },
      },
      {
        path: 'k3',
        name: 'game-k3',
        component: () => import('@/pages/games/k3/index.vue'),
        meta: {
          needCache: false,
          header: false,
          footer: false,
          login: true,
          loading: false,
        },
      },
    ],
  },
  {
    path: '/iframeRKF',
    name: 'iframeRKF',
    component: () => import('@/pages/games/iframe/rkf.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      login: true,
      loading: false,
    },
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    component: () => import('@/pages/wallet/deposit/Qrcode.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      login: true,
      loading: false,
      refresh: false,
      customHeader: {
        title: '充值',
      },
    },
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('@/pages/mine/index.vue'),
    meta: {
      needCache: true,
      footer: true,
      login: false,
      loading: false,
    },
  },
  {
    path: '/fundsDetail',
    name: 'fundsDetail',
    component: () => import('@/pages/mine/views/fundsDetail/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      login: true,
      loading: true,
      customHeader: {
        title: '资金明细',
      },
    },
  },
  {
    path: '/myReport',
    name: 'myReport',
    component: () => import('@/pages/mine/views/myReport/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      login: true,
      loading: false,
      customHeader: {
        title: '个人报表',
      },
    },
  },
  {
    path: '/mine/accountSetting',
    name: 'accountSetting',
    component: () => import('@/pages/mine/views/accountSetting/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      loading: true,
      login: true,
      refresh: false,
      customHeader: {
        title: '账户管理',
      },
    },
  },

  {
    path: '/modifyhead',
    name: 'modifyhead',
    component: () => import('@/pages/mine/views/modifyhead/index.vue'),
    meta: {
      needCache: true,
      footer: true,
    },
  },

  {
    path: '/betRecord',
    name: 'betRecord',
    component: () => import('@/pages/mine/views/betRecord/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      login: true,
      customHeader: {
        title: '投注记录',
      },
    },
  },
  {
    path: '/lotteryf',
    name: 'lotteryf',
    component: () => import('@/pages/mine/views/lotteryf/index.vue'),
    meta: {
      needCache: false,
      footer: false,
    },
  },
  {
    path: '/favorite',
    name: 'favorite',
    component: () => import('@/pages/mine/views/favorite/index.vue'),
    meta: {
      needCache: false,
      footer: true,
    },
  },
  {
    path: '/myshare',
    name: 'myshare',
    component: () => import('@/pages/mine/views/myshare/index.vue'),
    meta: {
      needCache: false,
      footer: true,
    },
  },
  {
    path: '/agentCenter',
    name: 'agentCenter',
    component: () => import('@/pages/mine/views/agentCenter/index.vue'),
    meta: {
      needCache: false,
      footer: true,
      login: true,
    },
  },
  {
    path: '/agentCenterRegister',
    name: 'agentCenter-register',
    component: () => import('@/pages/mine/views/agentCenter/register/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      loading: true,
      refresh: true,
    },
  },
  {
    path: '/agentCenter/subMemberDetail',
    name: 'agentCenter-subMemberDetail',
    component: () => import('@/pages/mine/views/agentCenter/member/subMemberDetail.vue'),
    meta: {
      needCache: false,
      footer: false,
    },
  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    component: () => import('@/pages/mine/views/helpCenter/index.vue'),
    meta: {
      needCache: false,
      footer: false,
    },
  },
  {
    path: '/findBalance',
    name: 'findBalance',
    component: () => import('@/pages/mine/views/findBalance/index.vue'),
    meta: {
      needCache: false,
      header: false,
      footer: false,
      login: true,
      loading: true,
      customHeader: {
        title: '找回余额',
      },
    },
  },
  {
    path: '/bonusCenter',
    name: 'bonusCenter',
    component: () => import('@/pages/mine/views/BonusCenter/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      login: true,
      loading: false,
      customHeader: {
        title: '福利中心',
      },
    },
  },
  {
    path: '/selfrebate',
    name: 'selfrebate',
    component: () => import('@/pages/mine/views/selfrebate/index.vue'),
    meta: {
      needCache: false,
      footer: true,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/pages/mine/views/about/index.vue'),
    meta: {
      needCache: false,
      footer: false,
    },
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/pages/mine/views/setting/index.vue'),
    meta: {
      needCache: false,
      footer: true,
      login: true,
      loading: false,
      customHeader: {
        title: '设置',
      },
    },
  },
  {
    path: '/information',
    name: 'information',
    component: () => import('@/pages/mine/views/setting/views/information.vue'),
    meta: {
      needCache: false,
      footer: false,
      loading: false,
      customHeader: {
        title: '个人信息',
      },
    },
  },
  {
    path: '/siteMessage',
    name: 'siteMessage',
    component: () => import('@/pages/mine/views/siteMessage/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      login: true,
    },
  },
  {
    path: '/resetPass',
    name: 'resetPass',
    component: () => import('@/pages/mine/views/setting/views/resetPass.vue'),
    meta: {
      needCache: false,
      layout: true,
    },
  },
  {
    path: '/resetPayPass',
    name: 'resetPayPass',
    component: () => import('@/pages/mine/views/setting/views/resetPayPass.vue'),
    meta: {
      needCache: false,
      footer: false,
    },
  },
  {
    path: '/userChatInfo',
    name: 'userChatInfo',
    component: () => import('@/pages/mine/views/userCharInfo/index.vue'),
    meta: {
      needCache: false,
      footer: true,
    },
  },
  {
    path: '/forgotPwd',
    name: 'forgotPwd',
    component: () => import('@/pages/mine/views/forgotPwd/index.vue'),
    meta: {
      needCache: false,
      footer: true,
    },
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('@/pages/mine/views/services/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      loading: false,
    },
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/pages/mine/views/services/faq.vue'),
    meta: {
      needCache: false,
      footer: false,
      loading: false,
      customHeader: {
        title: '常见问题',
      },
    },
  },
  {
    path: '/backupWebsites',
    name: 'backupWebsites',
    component: () => import('@/pages/mine/views/backupWebsites/index.vue'),
    meta: {
      needCache: false,
      footer: false,
      customHeader: {
        title: '备用网址',
      },
    },
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/pages/maintenance/index.vue'),
    meta: {
      needCache: false,
      footer: false,
    },
  },
  {
    path: '/trial',
    name: 'trial',
    component: () => import('@/pages/trial/index.vue'),
    meta: {
      needCache: false,
      footer: false,
    },
  },
  {
    path: '/red-packets',
    name: 'redPackets',
    component: () => import('@/pages/activity/activity/RedPacketsRain/index.vue'),
    meta: {
      needCache: false,
      refresh: true,
      loading: true,
    },
  },
  {
    path: '/test',
    name: 'test',
    redirect: '/test/i18n',
    component: () => import('@/pages/test/test.vue'),
    children: [
      {
        path: '/test/i18n',
        name: 'i18n',
        component: () => import('@/pages/test/i18n.vue'),
        meta: {
          needCache: false,
          footer: true,
          loading: false,
        },
      },
      {
        path: '/test/request',
        name: 'request',
        component: () => import('@/pages/test/request.vue'),
        meta: {
          needCache: false,
          footer: true,
        },
      },
      {
        path: '/test/theme',
        name: 'theme',
        component: () => import('@/pages/test/theme.vue'),
        meta: {
          needCache: false,
          footer: true,
        },
      },
      {
        path: '/test/svg',
        name: 'svg',
        component: () => import('@/pages/test/svg.vue'),
        meta: {
          needCache: false,
          footer: true,
        },
      },
    ],
  },
  ...modules,
  {
    path: '/:catchAll(.*)',
    name: '404',
    redirect: '/home/103',
  },
];

export default routes;
